import { Fight } from '../../domain/models/fight.model';
import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import {
  RetrieveFightsPayload,
  RETRIEVE_FIGHTS,
  RETRIEVE_FIGHTS_FAILURE,
  RETRIEVE_FIGHTS_SUCCESS,
} from './fight.action.type';

export const fightReducers = (state: AppState, action: AnyAction): AppState => {
  switch (action.type) {
    case RETRIEVE_FIGHTS:
      return retrieveFightsReducer(state, action);
    case RETRIEVE_FIGHTS_SUCCESS:
      return retrieveFightsSuccessReducer(state, action);
    case RETRIEVE_FIGHTS_FAILURE:
      return retrieveFightsFailureReducer(state, action);
    default:
      return state;
  }
};

const retrieveFightsReducer = (
  state: AppState,
  _action: Action<RetrieveFightsPayload>,
): AppState => {
  return {
    ...state,
    fights: {
      ...state.fights,
      isLoading: true,
    },
  };
};

export const retrieveFightsSuccessReducer = (
  state: AppState,
  action: Action<Fight[]>,
): AppState => {
  const existingFights = state.fights.fights || [];
  const newFights = action.payload;

  // Check if the new payload is equivalent to the existing state
  if (
    existingFights.length === newFights.length &&
    existingFights.every((fight, index) => fight.id === newFights[index].id)
  ) {
    return {
      ...state,
      fights: {
        ...state.fights,
        isLoading: false,
      },
    };
  }

  // If there are changes, update the state
  return {
    ...state,
    fights: {
      ...state.fights,
      fights: newFights,
      isLoading: false,
    },
  };
};

export const retrieveFightsFailureReducer = (
  state: AppState,
  action: Action<string>,
) => {
  return {
    ...state,
    fights: {
      ...state.fights,
      error: action.payload,
      isLoading: false,
    },
  };
};
